import React, { useState, useEffect } from 'react';
import '../css/HomePage.css';
import HomeHeader from '../Navigation/HomeHeader';
import { useNavigate } from 'react-router-dom';
function CandidateHome() {
  const [uid, setUid] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [interviewQuestions, setInterviewQuestions] = useState([]);
  const [roleName, setRoleName] = useState('');
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const handleFetchFile = async () => {
    const endpoint = `/fetch-file/${uid}`;
    const url = apiUrl + endpoint;
    console.log('Fetching file with UID:', uid);

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setJobDescription(data.jobDescription);
        setInterviewQuestions(data.interviewQuestions);
        setRoleName(data.roleName);
        console.log('File fetched successfully:', data);
      } else {
        console.error('Error fetching file:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching file', error);
    }
  };

  useEffect(() => {
    console.log('Interview questions:', interviewQuestions.length);
    if (interviewQuestions.length > 0) {
      console.log('uid', uid);
      console.log('roleName', roleName);
      navigate('/assessment-form', {
        state: {
          interviewQuestions,
          jobRole: roleName,
          Uid: uid
        }
      });
    } else {
      console.error('No interview questions available.');
    }
  }, [interviewQuestions, navigate, roleName]);

  return (
    <div className='homepage'>
      <HomeHeader />
      <h1>Candidate Home</h1>
      <input
        type="text"
        value={uid}
        onChange={(e) => setUid(e.target.value)}
        placeholder="Enter UID"
      />
      <button onClick={handleFetchFile}>Fetch Evaluation</button>
    </div>
  );
}

export default CandidateHome;